<!-- Table Import Catalog Detail  -->
<div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
  <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left"
    routerLink="/loyalty/import-gift" label="{{ 'common.back' | translate }}"></button>
</div>
<div class="ui-g-12">
  <app-kontable
  #importGiftTable
  title="{{ 'reservations.importedRows' | translate }}"
  [columns]="[
    {field: 'id', title: 'ID'},
    {field: 'row_index', title: 'reservations.rowIndex'},
    {field: 'CODICE_ARTICOLO', title: 'reservations.itmCode'},
    {field: 'DESCRIZIONE', title: 'common.description'},
    {field: 'NOME_IMG_FILE', title: 'reservations.nameFile'},
    {field: 'img_b64', title: 'common.image', bodyTemplate: imageB64, filterTemplate: nofilter, filterType: customFilter}
  ]"
  [service]="importRowsService"
  [paginationType]="paginationType"
  [showRecoverButton]="false"
  [showInfoButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showDetailsButton]="false"
  [showEditButton]="false"
  [showReport]="false"
  [showGlobalFilter]="false"
>
<ng-template #imageB64 let-row>
  <span *ngIf="row.img_b64">{{ 'reservations.imageImported' | translate }}</span>
  <span *ngIf="!row.img_b64">{{ 'reservations.imageNotImported' | translate }}</span>
</ng-template>

<ng-template #nofilter data-testid="nofilter" let-row>
</ng-template>

</app-kontable>

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-import-gift/import-gift-rows-detail/import-gift-rows-detail.component.html